import { useRef, useState, useEffect } from "react";
import { FieldArray } from "formik";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import ErrorMessage from "../../../components/helpers/ErrorMessage"
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import Badge from 'rsuite/Badge';
import 'rsuite/Badge/styles/index.css';
import MaskedInput from 'rsuite/MaskedInput';
import 'rsuite/Input/styles/index.css';
import 'rsuite/InputGroup/styles/index.css';

export default function Step4({
    formik,
    paqueteArray,
    step
}) {

    const [totalUsr, setTotalUsr] = useState([]);
    const [activeKey, setActiveKey] = useState("usr0");
    const usuarioRef = useRef(null);

    useEffect(() => {
        setActiveKey("usr0");
        if (step === 3 && usuarioRef.current !== null) {
            usuarioRef.current.focus();
        }
    },[step]);

    const opc = {
        mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        placeholder: '11-1111-1111'
    }

    const { setFieldValue } = formik;
    const { values } = formik;

    useEffect(() => {

        if (values.id_paquete === "201"){

            setTotalUsr([1]);
            setFieldValue(`usuarios.${0}.usuario`, 'notifica');
            setFieldValue(`usuarios.${0}.password`, '1qaz2WSX');
            setFieldValue(`usuarios.${0}.confirmacion`, '1qaz2WSX');

        } else {
            const conceptoP = paqueteArray.find(p => p.id_paquete === values.id_paquete);
            if(conceptoP){
                const { valor } = conceptoP.conceptos.find((c) => c.id_concepto === "14000");
                const totalUsuarios = Array.from({length : valor}, (_, i) => i + 1);
                setTotalUsr(totalUsuarios);
            }else {
                setTotalUsr([]);
            }

            if ( values.usuarios[0].usuario === 'notifica' ){
                setFieldValue(`usuarios.${0}.usuario`, '');
                setFieldValue(`usuarios.${0}.password`, '');
                setFieldValue(`usuarios.${0}.confirmacion`, '');
            }
        }
    },[paqueteArray, values, setFieldValue]);

    function addUser(key, e, arrayHelper){
        if (key === "addUsr"){
            e.stopPropagation();
            arrayHelper.push({
                usuario : "",
                password : "",
                confirmacion : "",
                nombre : "",
                email : "",
                tel_movil : ""
            })
            setActiveKey('usr' + formik.values.usuarios.length);
        } else{
            setActiveKey(key);
        }
    }

    return (
        <>
            <style>
                {`
                    .rs-badge-independent, .rs-badge-content{
                        padding : 0 !important;
                        background-color    : #f4433600!important;
                        top : 2px !important;
                    }
                `}
            </style>
            <div className="w-100">
                <div className="d-flex pb-8 pb-lg-10 justify-content-between">
                    <div>
                        <h2 className="fw-bold text-gray-900" tabIndex={-1}>Usuarios</h2>
                        <div className="text-muted fw-semibold fs-6">Crear credenciales de acceso.</div>
                    </div>
                    <div>
                        <h3 className={"fw-bold text-gray-900"}> ${values.costo} <span className={"fs-9 text-gray-600"} style={{paddingTop: "0.3rem"}}>MXN</span></h3>
                    </div>
                </div>
                <div className="card">
                    <FieldArray name={"usuarios"}
                                render={(arrayHelper) => {
                                    return (
                                        <Tabs
                                            defaultActiveKey={"usr0"}
                                            className={"mb-3 ms-auto"}
                                            variant={'underline'}
                                            activeKey={activeKey}
                                            onSelect={(eventKey, e) => addUser(eventKey, e, arrayHelper)}
                                        >
                                            {
                                                totalUsr.length > 1 && <Tab
                                                    eventKey={'addUsr'}
                                                    tabClassName={"p-0 text-active-primary text-hover-primary"}
                                                    title={
                                                        <TitleTooltip title={"Máximo " + totalUsr.length} placement={"top"}>
                                                            <i className="ki-duotone ki-message-add fs-2qx">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                            </i>
                                                        </TitleTooltip>
                                                    }
                                                    disabled={totalUsr.length === values.usuarios.length}
                                                ></Tab>
                                            }
                                            {
                                                values.usuarios && values.usuarios.length > 0 && values.usuarios.map((user, index) => {
                                                    return(
                                                        <Tab key={"usr" + index} tabClassName={"text-active-primary text-hover-primary p-0"} eventKey={"usr" + index}
                                                             title={
                                                                 <Badge content={
                                                                     index !== 0 && <i onClick={(e) => {
                                                                         e.stopPropagation();
                                                                         arrayHelper.remove(index);
                                                                         setActiveKey("usr0")
                                                                     }} className="bi bi-x"></i>
                                                                 }
                                                                        className={'p-0'}
                                                                 >
                                                                     <i className="ki-duotone ki-user-square fs-2qx">
                                                                         <span className="path1"></span>
                                                                         <span className="path2"></span>
                                                                         <span className="path3"></span>
                                                                     </i>
                                                                 </Badge>
                                                             }
                                                        >
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <div className="form-floating">
                                                                        <input
                                                                            ref={usuarioRef}
                                                                            type="text"
                                                                            className="form-control form-control-solid"
                                                                            id={`usuarios.${index}.usuario`}
                                                                            name={`usuarios.${index}.usuario`}
                                                                            placeholder="Usuario"
                                                                            value={user.usuario}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            required={index === 0}
                                                                            disabled={values.id_paquete === "201"}
                                                                        />
                                                                        <label htmlFor={`usuarios.${index}.usuario`} className="text-gray-700">Usuario</label>
                                                                    </div>
                                                                    <ErrorMessage name={`usuarios.${index}.usuario`}/>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <div className="form-floating">
                                                                        <input type={'password'}
                                                                               autoComplete={"off"}
                                                                               className="form-control form-control-solid"
                                                                               id={`usuarios.${index}.password`}
                                                                               name={`usuarios.${index}.password`}
                                                                               placeholder="Contraseña"
                                                                               value={user.password}
                                                                               onChange={formik.handleChange}
                                                                               onBlur={formik.handleBlur}
                                                                               required={index === 0}
                                                                               disabled={values.id_paquete === "201"}
                                                                        />
                                                                        <label htmlFor={`usuarios.${index}.password`} className="text-gray-700">Contraseña</label>
                                                                    </div>
                                                                    <ErrorMessage name={`usuarios.${index}.password`} />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <div className="form-floating">
                                                                        <input type='password'
                                                                               autoComplete={"off"}
                                                                               className="form-control form-control-solid"
                                                                               id={`usuarios.${index}.confirmacion`}
                                                                               name={`usuarios.${index}.confirmacion`}
                                                                               placeholder="Confirmar contraseña"
                                                                               value={user.confirmacion}
                                                                               onChange={formik.handleChange}
                                                                               onBlur={formik.handleBlur}
                                                                               required={index === 0}
                                                                               disabled={values.id_paquete === "201"}
                                                                        />
                                                                        <label htmlFor={`usuarios.${index}.confirmacion`} className="text-gray-700">Confirmar contraseña</label>
                                                                    </div>
                                                                    <ErrorMessage name={`usuarios.${index}.confirmacion`}/>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-floating">
                                                                        <input type="text"
                                                                               className="form-control form-control-solid text-uppercase"
                                                                               id={`usuarios.${index}.nombre`}
                                                                               name={`usuarios.${index}.nombre`}
                                                                               placeholder="Nombre de usuario"
                                                                               value={user.nombre}
                                                                               onChange={formik.handleChange}
                                                                               onBlur={formik.handleBlur}
                                                                               required={index === 0}
                                                                        />
                                                                        <label htmlFor={`usuarios.${index}.nombre`} className="text-gray-700">Nombre de usuario</label>
                                                                    </div>
                                                                    <ErrorMessage name={`usuarios.${index}.nombre`}/>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-lg-5">
                                                                    <div className="form-floating">
                                                                        <MaskedInput
                                                                            className="form-control form-control-solid"
                                                                            id={`usuarios.${index}.tel_movil`}
                                                                            name={`usuarios.${index}.tel_movil`}
                                                                            value={user.tel_movil}
                                                                            required={index === 0}
                                                                            mask={opc.mask}
                                                                            guide={true}
                                                                            showMask={false}
                                                                            keepCharPositions={false}
                                                                            placeholder={opc.placeholder}
                                                                            style={{ width: 'auto' }}
                                                                            onChange={(value) => setFieldValue(`usuarios.${index}.tel_movil`, value)}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        <label htmlFor={`usuarios.${index}.tel_movil`} className="text-gray-700">Teléfono Movil</label>
                                                                    </div>
                                                                    <ErrorMessage name={`usuarios.${index}.tel_movil`}/>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <div className="form-floating">
                                                                        <input type="email"
                                                                               className="form-control form-control-solid"
                                                                               id={`usuarios.${index}.email`}
                                                                               name={`usuarios.${index}.email`}
                                                                               placeholder="Email"
                                                                               value={user.email}
                                                                               onChange={formik.handleChange}
                                                                               onBlur={formik.handleBlur}
                                                                               required={index === 0}
                                                                        />
                                                                        <label htmlFor={`usuarios.${index}.email`} className="text-gray-700">Email</label>
                                                                    </div>
                                                                    <ErrorMessage name={`usuarios.${index}.email`}/>
                                                                </div>
                                                            </div>
                                                        </Tab>
                                                    );
                                                })
                                            }
                                        </Tabs>
                                    );
                                }}
                    />
                </div>
            </div>
        </>
    );
}
